import { mergeStyles, RangeInputGroup } from '@cian/components';
import { debounce } from 'lodash';
import * as React from 'react';
import { IRange } from '../../../../common/types';
import { Label } from '../../../../ui/label/label';
import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../../../types/redux';
import { squareChange } from '../../../../actions/filter';

const styles = require('../fields.css');

interface ISquareProps {
  square: IRange;
  squareChange(square: IRange): void;
}

interface ISquareState {
  error: boolean;
  min: number | undefined;
  max: number | undefined;
}

class Square extends React.PureComponent<ISquareProps, ISquareState> {
  public state: ISquareState = {
    error: false,
    min: undefined,
    max: undefined,
  };

  public UNSAFE_componentWillMount() {
    this.setState({ min: this.props.square.min, max: this.props.square.max });

    this.validate();
  }

  public UNSAFE_componentWillReceiveProps(nextProps: Readonly<ISquareProps>): void {
    this.setState({ min: nextProps.square.min, max: nextProps.square.max });
  }

  private setSquareMin = debounce((min: number | undefined) => {
    this.props.squareChange({ min, max: this.props.square.max });
  }, 1500);

  private setSquareMinValue = (min: number | undefined) => {
    this.setState({ min });

    this.setSquareMin(min);
  };

  private setSquareMax = debounce((max: number | undefined) => {
    this.props.squareChange({ min: this.props.square.min, max });
  }, 1500);

  private setSquareMaxValue = (max: number | undefined) => {
    this.setState({ max });

    this.setSquareMax(max);
  };

  public render() {
    const { error } = this.state;

    const rangeGroupStyle = mergeStyles(styles['range-group'], error && styles['error']);

    return (
      <Label text="Площадь:">
        <RangeInputGroup
          errorTextCommon="Максимальное значение должно быть больше минимального"
          rangeGroupStyle={rangeGroupStyle.className}
          min={{
            disableNegative: true,
            error,
            inputStyle: styles['range-input'],
            maxLength: 9,
            name: 'min',
            onBlur: this.validate,
            onValueChange: this.setSquareMinValue,
            placeholder: 'от',
            value: this.state.min,
          }}
          max={{
            disableNegative: true,
            error,
            inputStyle: styles['range-input'],
            maxLength: 9,
            name: 'max',
            onBlur: this.validate,
            onValueChange: this.setSquareMaxValue,
            placeholder: 'до',
            value: this.state.max,
          }}
        />
      </Label>
    );
  }

  private validate = () => {
    const { min, max } = this.props.square;

    this.setState({ error: min !== undefined && max !== undefined && min > max });
  };
}

export const SquareField = connect(
  (state: IApplicationState) => ({
    square: state.filter.query.square,
  }),
  (dispatch: TTypedThunkDispatch) => {
    return {
      squareChange: (square: IRange) => {
        dispatch(squareChange(square));
      },
    };
  },
)(Square);
